import { SiteItemData, SiteVideoData } from "../../../../interfaces";

interface VideoGalleryVerticalItemMutamProps {
    videoItem: SiteItemData
    videoIndex: number
    currentPromoIndex: number
    isPromoCarouselInView: boolean
    onVideoEnded: () => void
    onOpenVideoGalleryView: (e) => void
    pushGA4Event: (action: string, isFeedDisplay: boolean) => void
}

export class VideoGalleryVerticalItemMutam extends React.Component<VideoGalleryVerticalItemMutamProps, {}> {

    private videoRef;

    componentDidUpdate(prevProps: VideoGalleryVerticalItemMutamProps) {
        const { videoIndex, currentPromoIndex } = this.props;

        if (currentPromoIndex !== prevProps.currentPromoIndex && currentPromoIndex === videoIndex) {
            if (this.videoRef) {
                const videoElement = document.getElementById(`magazineVerticalVideoItem_${videoIndex}`);
                const videoRect = videoElement.getBoundingClientRect();
                const containerElement = document.querySelector(".videoGalleryVerticalMutamWrapper .frame_forList");
                const containerRect = containerElement.getBoundingClientRect();


                if (videoRect.left < containerRect.left || videoRect.right > containerRect.right) {
                    const scrollElement = document.querySelector(".videoGalleryVerticalMutamWrapper .slotListWrapper");
                    scrollElement.scrollBy({ behavior: 'smooth', left: videoRect.left - containerRect.left - 15 });
                }
            }
        }
    }

    private secondsToMinutesHandler = (seconds: number) => {
        const minutes = Math.floor(seconds / 60).toString().padStart(2, "0");
        const newSeconds = (seconds % 60).toString().padStart(2, "0");
        return `${minutes}:${newSeconds}`;
    }

    private onVideoError = () => {
        console.error("Video failed to load");
        this.props.onVideoEnded();
    }

    public render() {
        const { videoItem, onOpenVideoGalleryView, videoIndex, onVideoEnded, currentPromoIndex, isPromoCarouselInView } = this.props;
        const { media, title } = videoItem;
        const { duration, poster, promoPath } = media as SiteVideoData;
        const shouldDisplayPromo = isPromoCarouselInView && promoPath && currentPromoIndex === videoIndex;
        const slotClasses = `slotView ${shouldDisplayPromo ? "active" : ""}`;

        return (
            <div className={slotClasses} id={`magazineVerticalVideoItem_${videoIndex}`} onClick={() => onOpenVideoGalleryView(videoIndex)}>
                <div className="media-wrapper">
                    {shouldDisplayPromo &&
                        <video
                            muted
                            playsInline
                            loop={false}
                            src={promoPath}
                            poster={poster}
                            autoPlay={true}
                            webkit-playsInline
                            onEnded={onVideoEnded}
                            onError={this.onVideoError}
                            ref={ref => this.videoRef = ref}
                            className="promoVideo" 
                        >
                        </video>
                    }

                    <img src={poster} alt={media.title || "Video poster"} />
                </div>

                <div className="contentDiv">
                    <div className="videoTitle" dangerouslySetInnerHTML={{ __html: title }} />
                    <div className="videoDuration">
                        <span className="durationLogo"></span>
                        <span>{this.secondsToMinutesHandler(Math.round(duration))}</span>
                    </div>
                </div>
            </div>
        )
    }
}
